<template>
  <div class="content">
    <div class="header_content">
      <header class="van-hairline--bottom">
        <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
        <p>{{$route.meta.title}}</p>
        <van-button type="primary" class="btn_add" plain @click="showModel">活动规则</van-button>
      </header>
    </div>
    <div class="content">
      <div class="invite">
        <img src="../../assets/img/invite.png" alt />
      </div>

      <div class="imgs">
        <img src="../../assets/img/part3.png" alt />
      </div>

      <div class="lastImg">
        <div class="myIncome">
          <!-- <p>
            我的收益
          </p>-->
          <div class="myIncomeBox">
            <div class="left">
              <div style="color:#464646">已邀请</div>
              <div>
                <span>{{inviteRecord.hasInvitedNum}}</span>人
              </div>
            </div>
            <div class="right">
              <div style="color:#464646">共赚</div>
              <div>
                <span>{{inviteRecord.earnings}}</span>元
              </div>
            </div>
          </div>
        </div>
        <img src="../../assets/img/part4.png" alt />
      </div>
    </div>
    <div id="canvasImg" class="canvas" v-show="show">
      <canvas id="canvas" style="width:100%;height:100%"></canvas>
    </div>

    <van-dialog
      v-model="showRole"
      class="dialogs"
      :show-cancel-button="false"
      :showConfirmButton="false"
      closeOnClickOverlay
    >
      <img src="../../assets/img/rule_bg.png" alt class="bgImg" />
      <div class="rule_main">
        <!-- <img src="img/rule_txt.png" /> -->
        <p class="headers">Q:怎样算邀请成功？</p>
        <p>1.活动期间，发送邀请链接给好友，好友通过您分享的链接或码接受邀请注册成为悦买用户，即为邀请成功。（邀请对象仅限从未在悦买注册过的新用户）
        </p>
        <p class="headers">Q:邀请成功会得到什么？</p>
        <p>1.您邀请的好友注册后7天内的每单都将给您返现作为赏金，返现比例为好友每单消费额的5%（同一好友，返现累计最高15元）；
<br />2.您的好友注册成功可得88元新人礼包；</p>
        <p class="headers">Q:在哪里可以看到红包或赏金？</p>
        <p>1.赏金在好友交易完成后（且无退款）24小时内发放到您的钱包，您可在【钱包】内查看。赏金可提现。
        </p>
        <p class="headers">注意事项</p>
        <p>1.同一登录账号、同一手机、同一终端设备号、同一支付账户、同一IP或其他合理显示为同一用户的情形，均视为同一用户，不可互相邀请；
<br />2.若通过不正当手段获取奖励，经查实【悦买】有权撤销该用户的活动资格并取消其奖励。
        </p>
      </div>
      <van-icon name="clear" class="close" @click="showModel" />
    </van-dialog>

    <img src id="weChatImg" style="display:none" />
    <van-button type="default" class="btn_invite" @click="showPopup">立即邀请</van-button>
    <van-popup v-model="show" position="bottom" style="height: auto">
      <div class="model">
        <div @click="getShares('0')">
          <img src="../../assets/img/personal_invite_icon_wechat.png" alt />
          <span>微信</span>
        </div>
        <div @click="getShares('1')">
          <img src="../../assets/img/invite_wechat.png" alt />
          <span>朋友圈</span>
        </div>
      </div>
      <van-button type="default" class="closeModel" @click="showPopup">取消</van-button>
    </van-popup>
  </div>
</template>

<script>
import share from "@/assets/img/pop_share_red.jpeg";
import { getInviteRecord } from "@/api/buyer/index";
import { uploadImageBase64,getStartPageImage } from "@/api/picker/index";
export default {
  data() {
    return {
      isWX: "1",
      headerMsg: {
        url: "/joinup"
      },
      show: false,
      isiPhoneX: "",
      paths: "pages/bazaarIndex/bazaarIndex", //扫描小程序码跳转的路径，注意必须是已发布的小程序路径
      refereeId: this.GetQueryString("memberId"), //用户id
      phone: this.GetQueryString("phone"), //手机号
      baseURL: this.baseURL,
      shareImg: share,
      showRole: false,
      inviteRecord: {},
      imgPath: "",
      imgPrex:this.imgPrex,
    };
  },
  created() {
    this.$store.commit("user/SET_token", this.GetQueryString("token"));
    this.getInviteRecord();
    this.getStartPageImage();
  },
  mounted() {
    //   this.rule()
    // 进入页面开始绘制，再不重新刷新页面的情况下只绘制一次，避免重复绘制。
    // this.getCanvasImg();
  },

  methods: {
    returnBack() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.closeHandsel();
        } else {
          // ios环境
          window.webkit.messageHandlers.closeHandsel.postMessage("");
        }
      }
    },
    showPopup() {
      this.show = !this.show;
    },
    isIPhone() {
      var u1 = navigator.userAgent;
      var isIOS1 = !!u1.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS1) {
        if (screen.height == 812 && screen.width == 375) {
          //是iphoneX
          this.isiPhoneX = true;
        } else {
          //不是iphoneX
          this.isiPhoneX = false;
        }
      }
    },
    // canvas绘制邀请分享的图片
    getCanvasImg(imgUrl) {
      let that = this;
      let oCanvas = document.getElementById("canvas");
      let ctx = oCanvas.getContext("2d");
      this.isIPhone();
      this.isWX = this.GetQueryString("wx");
      if (this.isiPhoneX) {
        oCanvas.width = "1128";
        oCanvas.height = "1648";
      } else {
        oCanvas.width = "564";
        oCanvas.height = "824";
      }
      ctx.clearRect(0, 0, oCanvas.width, oCanvas.height);
      if (this.isiPhoneX) {
        ctx.scale(4, 4);
      } else {
        ctx.scale(2, 2);
      }
      //			ctx.fillStyle = '#FFEEDE'
      //			ctx.fillRect(0, 0, 564, 664)
      //   roundRect(0, 0, 282, 332, 20, "#FFEEDE", "#fff");
      var img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = imgUrl;
      // console.log(img);
      // img.style.width = "282px";
      // img.style.height = "332px";
      img.onload = function() {
        ctx.drawImage(img, 0, 0, 1128, 1288, 0, 0, 282, 332); //绘制图片
      };
      //var clientWidth = document.documentElement.clientWidth;
      // var imgs = new Image();
      // imgs.src = 'img/sologan.png'
      // imgs.onload = function() {
      // 	ctx.drawImage(imgs, 0, 0, 497, 565, 95, 605, 497, 565); //绘制图片
      // }
      ctx.stroke();
      //   var imgse = new Image();
      //   imgse.src = "img/pop_share_bg_under.png";
      //   imgse.onload = function() {
      //     ctx.drawImage(imgse, 0, 0, 564, 160, 0, 332, 282, 80); //绘制图片
      //   };
      ctx.fillStyle = "#fff";
      ctx.textBaseline = "top";
      ctx.fillRect(0, 0, oCanvas.width, oCanvas.height);
      ctx.font = "14px Arial";
      ctx.fillStyle = "#000";
      ctx.fillText(this.phone, 100, 355);
      ctx.fillText("邀请您注册悦买", 100, 379);
      let wximg = new Image();
      wximg.src = document.getElementById("weChatImg").src =
        this.baseURL +
        "wx/getWXQrcode?width=120&scene=" +
        this.refereeId +
        "&refereeType=4&page=" +
        this.paths;
      wximg.onload = function() {
        ctx.drawImage(wximg, 0, 0, 280, 280, 10, 342, 60, 60); //绘制图片
        // 生成base64图片并传给后台返回url
        let strDataURI = oCanvas.toDataURL();
        that.getWeChatCodeImg(strDataURI.split(",")[1]);
      };
      ctx.save();
    },
    getWeChatCodeImg(code) {
      uploadImageBase64({
        fileContent: code
        //参数
      }).then(res => {
        // OnSuccess function
        this.imgPath = res.content.path;
      });
    },
    showModel() {
      this.showRole = !this.showRole;
    },
    getInviteRecord() {
      getInviteRecord({
        token: this.GetQueryString("token")
      }).then(res => {
        this.inviteRecord = res.content;
      });
    },
    getShares(type) {
      // if (this.imgPath == "") {
      //   return;
      // }
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.getShare(this.imgPath, type);
        } else {
          // ios环境
          window.webkit.messageHandlers.getShare.postMessage({
            imgPath: this.imgPath,
            type: type
          });
        }
        this.show = false;
      }
    },
    getStartPageImage(){
      getStartPageImage({type:6}).then(res => {
        // console.log(res)
        if(res.content.startPageImage){
          this.$nextTick(() => {
            this.getCanvasImg(this.imgPrex + res.content.startPageImage)
          })
        }else {
          this.$nextTick(() => {
            this.getCanvasImg(this.shareImg)
          })
        }
      }).catch(err => {
        this.$nextTick(() => {
          this.getCanvasImg(this.shareImg)
        })
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  height: auto;
  .header_content {
    height: 44px;
    header {
      display: flex;
      align-items: center;
      position: fixed;
      top: 0;
      z-index: 2000;
      width: 100%;
      height: 44px;
      background: #fff;
      i {
        font-size: 26px;
        position: absolute;
        left: 0;
        top: 8px;
        z-index: 88;
      }
      p {
        font-size: 17px;
        margin: 0;
        position: absolute;
        left: 0;
        right: 0;
        top: 10px;
        z-index: 87;
      }
      .btn_add {
        width: 102.5px;
        height: 35px;
        line-height: 35px;
        border: 1px solid #ec130c;
        color: #ec130c;
        font-size: 17px;
        position: absolute;
        top: 4.5px;
        right: 8px;
        z-index: 89;
      }
    }
  }
  .content {
    width: 100%;
    height: 100%;
    background: #c41b22;
    .invite {
      img {
        width: auto;
        height: 110px;
      }
    }
    .imgs {
      img {
        width: auto;
        height: 290px;
      }
    }
    .lastImg {
      position: relative;
      margin-top: 25px;
      padding-bottom: 80px;
      img {
        width: auto;
        height: 158px;
      }
      .myIncome {
        position: absolute;
        width: 92%;
        left: 15px;
        top: 40px;
        p {
          text-align: left;
          color: #333333;
          font-size: 16px;
          height: 32px;
          line-height: 32px;
          padding-left: 12px;
          background-color: #f5f5f5;
          margin: 0;
        }
        .myIncomeBox {
          display: flex;
          font-size: 14px;
          color: #464646;
          margin-top: 12px;
          .left {
            flex: 1;
            div {
              margin-top: 14px;
              color: #ff3b35;
              span {
                font-size: 30px;
              }
            }
          }
          .right {
            flex: 1;
            div {
              margin-top: 14px;
              color: #ff3b35;
              span {
                font-size: 30px;
              }
            }
          }
        }
      }
    }
  }
  .canvas {
    width: 282px;
    height: 412px;
    position: fixed;
    top: 10%;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 9999;
  }
  .dialogs {
    width: 343px;
    height: 575px;
    text-align: left;
    margin-top: 30px;
    background: none !important;

    .bgImg {
      width: 100%;
      height: 540px;
      position: absolute;
      z-index: 11;
    }
    /deep/.van-dialog__content {
      width: 100%;
      height: 100%;
      .rule_main {
        width: auto;
        height: 480px;
        margin: 52px 14px 30px;
        position: absolute;
        z-index: 22;
        overflow: auto;
        p {
          color: #883b07;
          font-size: 14px;
          padding: 0;
        }
        p:nth-child(even) {
          white-space: pre-wrap;
        }
        .headers {
          font-weight: bold;
          margin-top: 6px;
        }
      }
      /deep/.close {
        font-size: 30px;
        color: #fff;
        position: absolute;
        z-index: 9999;
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        text-align: center;
      }
    }

    // img:not(.closeImg) {
    //   width: 100%;
    //   height: auto;
    //   display: block;
    //   /* margin: 1.3rem auto 0; */
    // }
  }
  .model {
    width: 100%;
    height: 115px;
    display: flex;
    // border-bottom: 1px solid #f5f5f5;
    div {
      flex: 1;
      text-align: center;

      img {
        width: 61px;
        height: 61px;
        display: block;
        margin: 17px auto 0;
      }
      span {
        font-size: 14px;
        color: #666;
        display: block;
      }
    }
  }
  .closeModel {
    width: 100%;
    height: 49px;
    line-height: 49px;
    color: #333;
    font-size: 16px;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
  .btn_invite {
    width: 345px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 23px;
    background: rgba(248, 187, 1, 1);
    border: 1px solid rgba(248, 187, 1, 1);
    border-radius: 25px;
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .cont {
    height: fit-content;
    //   margin-top: 50px;
  }
  .mt {
    height: fit-content;
    margin-top: 0;
  }
}
</style>
